import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import { P, SectionHeading, SectionSmallHeading, SectionSubHeading, SectionSubWrapper, SectionWrapper } from "../../Styles/style";
import reflect from "../../../assets/images/roadmapimg2.png"
import img from "../../../assets/images/img.png"

const AboutImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 15%;
  position:absolute;
  left:0;
  bottom:0px;
  @media screen and (max-width:1224px){
    bottom:8px;
 }
  @media screen and (max-width:1024px){
    bottom:12px;
 }
  @media screen and (max-width:999px){
display:none;
 }
`;
const VideoBK = styled.video`
  object-fit: cover;
  width: 100%;
  max-width: 100%;
  height: auto;
`; const GridHEading = styled(Grid)`
/* padding: 50px 0; */
align-items: center;

place-content: ${(props) => (props.pc ? props.pc : "center")};
`;
const GridImage = styled(Grid)`
padding: 50px 0;
/* place-content: ${(props) => (props.pc ? props.pc : "center")};
text-align: center; */
text-align: left;
`;
const JOiningLinks = styled.img`
  width: 100%;
  height:auto;
  max-width: ${(props) => (props.mw ? props.mw : "1100PX")};
  @media screen and (max-width:1299px){
   max-width: ${(props) => (props.mw ? props.mw : "790PX")};
 }
  @media screen and (max-width:899px){
    display:none;
   max-width: ${(props) => (props.mw ? props.mw : "790PX")};
 }
`
const FeatureWrapper = styled.div`
 background: 
    linear-gradient(#000000 0 0) padding-box, /*this is your grey background*/
    linear-gradient(319deg, #000,#000,#000, #1765FF) border-box;
  border: 1px solid transparent;
backdrop-filter: blur(13px) !important;
  padding: 20px;
`
const BuyNow = styled.a`
text-decoration: none;
background-color: #166815;
color: ${(props) => (props.Color ? props.Color : props.theme.textPrimary)};
border-radius: 25px;
padding: 10px 50px;
margin-right: 15px;
font-family:"Rockkb";
border:1px solid #000;
@media screen and (max-width:499px){
  padding: 8px 25px;

}

`
const S2_Aboutus = () => {
  return (
    <div>
      <SectionSubWrapper p="4rem 0" id="about">
        <Container maxWidth="xl">
          <SectionSubHeading
            p="0px 0 60px"
            fs="50px"
            m="0"
            data-aos="flip-up"
            data-aos-easing="ease-in"
            data-aos-delay="400"
            data-aos-duration="400"
            data-aos-offset="0"
          >PEPE-NOMICS
          </SectionSubHeading>

          <JOiningLinks src={reflect} data-aos="fade-zoom-in"
            data-aos-easing="ease-in"
            data-aos-delay="500"
            data-aos-duration="600"
            data-aos-offset="0" />
          <Grid container>
            <Grid item xs={12} md={4}>
              <P p="30px 0 10px"
                m="0" align="center">Fair Launch</P>
              <P
                maxWidth="68%"
                p="0 0 40px 0"
                m="0"
                align="center"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="700"
                data-aos-duration="600"
                data-aos-offset="0"
              >
             Everyone get's an equal footing. No one has to miss out on Mini Pepe's watch!

                </P>
            </Grid>
            <Grid item xs={12} md={4}>
              <P   p="30px 0 10px"
                m="0" align="center">No Taxes</P>
              <P
                maxWidth="68%"
                p="0 0 40px 0"
                m="0"
                align="center"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="700"
                data-aos-duration="600"
                data-aos-offset="0"
              >
            Mini Pepe's a minor. He doesn't understand taxes and says he doesn't bother with em!

                </P>
            </Grid>
            <Grid item xs={12} md={4}>
              <P align="center" p="30px 0 10px"
                m="0" >LP Burn</P>
              <P
                maxWidth="68%"
                p="0 0 40px 0"
                m="0"
                align="center"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="700"
                data-aos-duration="600"
                data-aos-offset="0"
              >
           All the LP will be burnt up. No rugs, no pulls!
                </P>
            </Grid>
          
          </Grid>
       <AboutImage src={img}/>

        </Container>
        <Grid container>
          <Grid item xs={12} md={4}>
            
          </Grid>
          <Grid item xs={12} md={4}>
            
            <SectionSubHeading align="CENTER">Total supply</SectionSubHeading>
            <P m="0" align="CENTER">69,696,969,696,969</P>
            <SectionSubHeading align="CENTER">Contract</SectionSubHeading>
            

          </Grid>
          <Grid item xs={12} md={4}>
            <SectionSubHeading>Tokenomics with more PEP!</SectionSubHeading>

          </Grid>
        </Grid>
      </SectionSubWrapper>
    </div>
  );
};

export default S2_Aboutus;
